import { Injectable } from '@angular/core';
import { Paginator, SortDirection } from '@app/classes';
import { AnalyticEvents } from '@app/enums';
import { Table } from '@app/modules/table/classes/table.class';
import { AnalyticService, AuthService } from '@app/services';
import {
    ArchivedColumn,
    DateAddedColumn,
    FullNameColumn,
    JobPostingColumn,
} from '@applicant-tracker/services/tables/applicants-table/columns';
import { JobFunnelColumn } from '@applicant-tracker/services/tables/applicants-table/columns/job-funnel.column';
import { RatingColumn } from '@applicant-tracker/services/tables/applicants-table/columns/rating.column';
import { Applicant } from '@models/recruiting/applicant.model';

@Injectable()
export class ApplicantsIndexTable extends Table {
    sortDirection = SortDirection.ASC;
    links = true;
    protected sortProperty = 'lastName';

    constructor(
        protected auth: AuthService,
        private analyticService: AnalyticService
    ) {
        super(auth);
        this.boot();
    }

    getLink(applicant: Applicant): (string | number)[] {
        return ['/recruiting', 'applicants', applicant.id];
    }

    setColumns(): void {
        const companyId = this.auth.company.id;
        const nameColumn = new FullNameColumn();

        this.columns = [];

        const columns = [
            nameColumn,
            new JobPostingColumn(companyId),
            new DateAddedColumn(),
            new ArchivedColumn(),
            new RatingColumn(),
            new JobFunnelColumn(
                companyId,
                this.analyticService,
                AnalyticEvents.RecruitingAllApplicantsChangeApplicantFunnelStage
            ),
        ];

        this.addColumns(...columns);

        this.sortColumn = nameColumn;
    }

    setDataSource(): void {
        this.paginator = new Paginator(
            Applicant.param('company', this.auth.company.id).with(['jobPosting', 'jobPosting.jobFunnels'])
        );
    }

    onRate(_rowId: number, _value: number): void {}
}
